
const basename = string => {
  const points = []

  let char = 0
  let previous = 0
  let i = 0

  while (i < string.length) {
    char = string.charCodeAt(i++)

    if (previous) {
      points.push((0x10000 + ((previous - 0xd800) << 10) + (char - 0xdc00)).toString(16))
      previous = 0
    } else if (char > 0xd800 && char <= 0xdbff) {
      previous = char
    } else {
      points.push(char.toString(16))
    }
  }

  return points.join('-')
}

export default {
  name: 'VsEmoji',
  props: {
    value: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'png'
    },
    size: {
      type: [String, Number],
      default: 72
    }
  },
  vessel: {
    image: {
      $attrs: 'all'
    }
  },
  computed: {
    source() {
      const icdn = 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2'
      const name = basename(this.value)
      const size = 72

      if (this.type == 'png') {
        return `${icdn}/${size}x${size}/${name}.png`
      } else {
        return `${icdn}/svg/${name}.svg`
      }
    }
  }
}
